import request from "@/utils/request";

/** 只读当前登录人的完整未读汇总，不传目标用户ID，也不附带标记已读动作。 */
export const getChatInboxSummary = () => request({
  url: "/api/mts-api/chat/inbox-summary",
  method: "get",
  skipLoading: true,
  skipErrorMessage: true,
  skipAuthRedirect: true,
});
